<template>
  <small-modal
    :title="$t('productPages.deleteModal.title')"
    class="delete-campaign-modal"
    :fit-content="true"
    @close="close"
  >
    <div class="delete-campaign-modal-container">
      <h3 class="subtitle">{{ $t("productPages.deleteModal.subtitle") }}</h3>
      <banner-modal
        banner-type="warning"
        :title="$t('deleteCampaign.warning')"
        :text="$t('productPages.deleteModal.banner')"
      >
      </banner-modal>
      <div class="buttons">
        <input
          class="button-primary --grey"
          type="button"
          :value="$t('deleteCampaign.cancel')"
          @click.prevent="close"
        />
        <label class="button-primary button-flex --red">
          <input
            class="submit-button"
            type="submit"
            :value="$t('deleteCampaign.delete')"
            @click="deleteProduct"
          />
          <DeleteIcon class="delete-icon" />
        </label>
      </div>
    </div>
    <spinner-loader v-if="isLoading"></spinner-loader>
  </small-modal>
</template>

<script>
import { mapState } from "vuex";

import SmallModal from "@/components/shared/SmallModal";
import SpinnerLoader from "@/components/shared/SpinnerLoader.vue";
import DeleteIcon from "@/assets/svg/delete-small.svg?inline";
import BannerModal from "@/components/shared/BannerModal.vue";

export default {
  components: {
    DeleteIcon,
    SmallModal,
    SpinnerLoader,
    BannerModal,
  },
  props: {
    productToDelete: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      campaignsState: ({ campaign }) => campaign.campaigns,
    }),
  },

  methods: {
    close() {
      this.$emit("close");
    },
    deleteProduct() {
      const productId = this.productToDelete._id;
      this.$emit("delete-product", productId);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-campaign-modal-container {
  width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.subtitle {
  text-align: center;
  @include font-normal;
}

.delete-icon {
  transform: scale(175%);
}

/*save and back button*/
.buttons {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 24px;
}

.button-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.submit-button {
  @include base-font;
  @include font-small;
  font-weight: 500;
  background: none;
  border: none;
}
.--red {
  box-shadow: 2px 2px 15px 0px rgba(235, 0, 0, 0.25);
  &:hover {
    background-color: rgba(235, 0, 0, 0.25);
  }
}

@include media(">phone", "<=tablet") {
  .card-title {
    margin-top: 1rem;
    margin-bottom: 1rem;
    @include font-normal;
  }

  .subtitle {
    @include font-small;
  }
}

@include media("<=phone") {
  .card-title {
    margin-top: 1rem;
    margin-bottom: 1rem;
    @include font-normal;
  }
}
</style>
